export function checkAuthAndRedirect(navigate) {
  const userId = sessionStorage.getItem('user_id') || sessionStorage.getItem('player_id');
  if (!userId) {
    // Check if redirect_path is already set
    if (!sessionStorage.getItem('redirect_path')) {
      const currentPath = window.location.pathname + window.location.search;
      console.log('Current Path:', currentPath);
      sessionStorage.setItem('redirect_path', currentPath);
    }
    navigate('/');
  }
}

export function logout() {
  // Clear session storage
  sessionStorage.clear();

  // Clear cookies
  document.cookie.split(";").forEach((c) => {
    document.cookie = c
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
  });

  // Redirect to login or home page
  window.location.href = "/";
}

export const isAdmin = () => sessionStorage.getItem('is_admin') === 'true'; 